import _ from "lodash";
import { UniAnswer } from "../../dao/UniAnswer";
import { UniForm } from "../../dao/UniForm";
import { UiMetaTable } from "../FrmSpwkQuestV3/UiMetaTable";
import { UNKNOWN, CommonExportUtil as Util } from "./CommonExportUtil";
import { Project } from "../../dao/Project";
import { Member } from "../../dao/Member";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";
import { RHF_NAME_上背, RHF_NAME_下背, RHF_NAME_右手_右手腕, RHF_NAME_右手肘_右前臂, RHF_NAME_右肩, RHF_NAME_右腳踝_右腳, RHF_NAME_右膝, RHF_NAME_右臀_右大腿, RHF_NAME_左手_左手腕, RHF_NAME_左手肘_左前臂, RHF_NAME_左肩, RHF_NAME_左腳踝_左腳, RHF_NAME_左膝, RHF_NAME_左臀_左大腿, RHF_NAME_頸 } from "../../components/uni/UcHumanBodyImage";



export class F03_ExportManager {

  static Export_F03v0(common_form: UniForm, meta_table: UiMetaTable, answer_list: UniAnswer[], _Project: Project, sel_member_list: Member[]): F03_ExportData[] {
    let export_list: F03_ExportData[] = [];

    for (const ans of answer_list) {
      let rhf_data = ans.ConvertToCommonRhfData();

      let export_data: F03_ExportData = new F03_ExportData();

      //#region 帶入基本資料
      let sel_ans_member = sel_member_list.find(member => member.guid === ans.member_guid); //取得該ans的member資料

      export_data.填寫日期 = Util.填寫日期(ans);

      export_data.項次 = Util.項次();

      export_data.廠區 = Util.廠區(_Project);
      // let 廠區RULE: Table = {
      //   "台南一廠": "台南一廠",
      //   "台南二廠": "台南二廠",
      //   "其他": Util.GetString(rhf_data, "m01.廠區●其他●input_1")
      // }
      // export_data.廠區 = Util.OptionValue(meta_table, rhf_data, "m01.廠區", UNKNOWN, 廠區RULE);
      export_data.部門代號 = Util.部門代號();
      export_data.部門名稱 = Util.部門名稱(sel_ans_member);

      export_data.工號 = Util.工號(sel_ans_member);//XXX 改以 member 為準 Util.GetString(rhf_data, "m01.基本資訊●工號●input_1");
      export_data.姓名 = Util.姓名(sel_ans_member);//XXX 改以 member 為準 Util.GetString(rhf_data, "m01.基本資訊●姓名●input_1");
      export_data.健檢日期 = Util.健檢日期(sel_ans_member);

      export_data.性別 = Util.性別(ans, sel_ans_member);

      //#endregion

      export_data.年齡 = Util.GetString(rhf_data, "m01.基本資料●年齡●input_1");
      export_data.身高 = Util.GetString(rhf_data, "m01.基本資料●身高●input_1");
      export_data.體重 = Util.GetString(rhf_data, "m01.基本資料●體重●input_1");

      export_data.慣用手 = Util.OptionValue(meta_table, rhf_data,
        "m01.慣用手", UNKNOWN, {
        "左手": "左",
        "右手": "右",
      });

      export_data.在過去的1年內身體是否有長達2星期以上 = Util.OptionValue(meta_table, rhf_data,
        "m02.1年內長期身體不適", UNKNOWN, null
      );

      if (export_data.在過去的1年內身體是否有長達2星期以上 === "是") {// 填 "是" 才要往下填寫

        export_data.頸部 = GetScore(rhf_data, RHF_NAME_頸);
        export_data.左肩 = GetScore(rhf_data, RHF_NAME_左肩);
        export_data.左手肘_左前臂 = GetScore(rhf_data, RHF_NAME_左手肘_左前臂);
        export_data.左手_左手腕 = GetScore(rhf_data, RHF_NAME_左手_左手腕);
        export_data.左臀_左大腿 = GetScore(rhf_data, RHF_NAME_左臀_左大腿);
        export_data.左膝 = GetScore(rhf_data, RHF_NAME_左膝);
        export_data.左腳踝_左腳 = GetScore(rhf_data, RHF_NAME_左腳踝_左腳);

        export_data.上背 = GetScore(rhf_data, RHF_NAME_上背);
        export_data.右肩 = GetScore(rhf_data, RHF_NAME_右肩);
        export_data.右手肘_右前臂 = GetScore(rhf_data, RHF_NAME_右手肘_右前臂);
        export_data.下背 = GetScore(rhf_data, RHF_NAME_下背);
        export_data.右手_右手腕 = GetScore(rhf_data, RHF_NAME_右手_右手腕);
        export_data.右臀_右大腿 = GetScore(rhf_data, RHF_NAME_右臀_右大腿);
        export_data.右膝 = GetScore(rhf_data, RHF_NAME_右膝);
        export_data.右腳踝_右腳 = GetScore(rhf_data, RHF_NAME_右腳踝_右腳);

        export_data.上圖的身體部位酸痛不適或影響關節活動之情形持續多久時間 = Util.OptionValue(meta_table, rhf_data,
          "m04.不適持續時間", UNKNOWN, null
        );

        export_data.您是否曾被醫師確診肌肉骨骼或神經系統相關疾病 = Util.OptionValue(meta_table, rhf_data,
          "m04.醫師診斷有疾病", UNKNOWN,
          {
            "是": "是，診斷名稱:" + Util.GetString(rhf_data, "m04.醫師診斷有疾病●是●input_1"),
            "否": "否",
          }
        );

        export_data.其他症狀_病史說明 = Util.GetString(rhf_data, "m04.其他●其他●input_1").replaceAll("\r\n", "/").replaceAll("\r", "/").replaceAll("\n", "/");

        let rslt: { item_string: string, total_score: string } = 顯示三分以上項目(export_data);
        export_data.三分以上項目 = rslt.item_string;
        export_data.肌肉骨骼總分 = rslt.total_score;

      }



      export_list.push(export_data);
    }

    return export_list;
  }




}


function 顯示三分以上項目(export_data: F03_ExportData): { item_string: string, total_score: string } {

  // 將3分以上的文字串在一起
  let item_list: string[] = [];

  let score_list: number[] = [];

  // 注意! 以下文字並分是 rhf_name，而是要匯出的文字
  Concat_Score(score_list, item_list, export_data.頸部, "頸部");
  Concat_Score(score_list, item_list, export_data.左肩, "左肩");
  Concat_Score(score_list, item_list, export_data.左手肘_左前臂, "左手肘/左前臂");
  Concat_Score(score_list, item_list, export_data.左手_左手腕, "左手/左手腕");
  Concat_Score(score_list, item_list, export_data.左臀_左大腿, "左臀/左大腿");
  Concat_Score(score_list, item_list, export_data.左膝, "左膝");
  Concat_Score(score_list, item_list, export_data.左腳踝_左腳, "左腳踝/左腳");

  Concat_Score(score_list, item_list, export_data.上背, "上背");
  Concat_Score(score_list, item_list, export_data.右肩, "右肩");
  Concat_Score(score_list, item_list, export_data.右手肘_右前臂, "右手肘/右前臂");
  Concat_Score(score_list, item_list, export_data.下背, "下背");
  Concat_Score(score_list, item_list, export_data.右手_右手腕, "右手/右手腕");
  Concat_Score(score_list, item_list, export_data.右臀_右大腿, "右臀/右大腿");
  Concat_Score(score_list, item_list, export_data.右膝, "右膝");
  Concat_Score(score_list, item_list, export_data.右腳踝_右腳, "右腳踝/右腳");

  if (item_list.length === 0) {// 沒有3分以上的
    return { item_string: "", total_score: "" };

  } else {
    if (item_list.includes(UNKNOWN)) {// 有無法處理的分數
      return { item_string: UNKNOWN, total_score: UNKNOWN };

    } else {// 有3分以上的部位，顯示部位 與 3分以上的總分
      let str = item_list.join("、");
      let total = score_list.reduce((a, b) => a + b, 0);// 加總

      return { item_string: str, total_score: ("" + total) };// 顯示3分以上的部位，與3分以上累積分數
    }
  }

}

/**
  * 超出指定分數再加入 score_list 與 item_list
  * 如果分數為 NAN 無法解析 ，則加入 UNKNOWN(XXXXX)，到外面處理
  * 
  * 注意! 只累加3分以上的部位 與 分數。 0、1、2 的部位忽略
  */
function Concat_Score(score_list: number[], item_list: string[], score: string, str: string): void {
  let score_to_number_type = Number(score); //轉成Number型別

  if (isNaN(score_to_number_type)) {// 無法解析為分數
    item_list.push(UNKNOWN);
    score_list.push(score_to_number_type);

  } else if (score_to_number_type >= 3 && score_to_number_type <= 5) {
    item_list.push(str);
    score_list.push(score_to_number_type);// 加入分數

  } else if (score_to_number_type >= 0 && score_to_number_type <= 2) {
    //pass 不到3分得不用處理
  } else {
    throw new_ErrorAlert("99221 score不在範圍內");
  }
}


export class F03_ExportData {
  填寫日期 = "";
  //----------------
  項次 = "";

  廠區 = "";
  部門代號 = "";
  部門名稱 = "";

  工號 = "";
  姓名 = "";
  健檢日期 = "";

  性別 = "";
  //---------------
  年齡 = "";
  身高 = "";
  體重 = "";
  慣用手 = "";

  在過去的1年內身體是否有長達2星期以上 = "";

  //--------------
  頸部 = "";
  左肩 = "";
  左手肘_左前臂 = "";
  左手_左手腕 = "";
  左臀_左大腿 = "";
  左膝 = "";
  左腳踝_左腳 = "";

  上背 = "";
  右肩 = "";
  右手肘_右前臂 = "";
  下背 = "";
  右手_右手腕 = "";
  右臀_右大腿 = "";
  右膝 = "";
  右腳踝_右腳 = "";
  //------------------

  上圖的身體部位酸痛不適或影響關節活動之情形持續多久時間 = "";
  您是否曾被醫師確診肌肉骨骼或神經系統相關疾病 = "";
  其他症狀_病史說明 = "";

  三分以上項目 = "";
  肌肉骨骼總分 = "";


}

function GetScore(rhf_data: any, rhf_name: string): string {
  return Util.GetString(rhf_data, rhf_name) === "" ? "0" : Util.GetString(rhf_data, rhf_name);
}

